import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

export default function FinalCTASection() {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  return (
    <section
      className="py-24 md:py-32 border-t border-[var(--landing-border)]"
      style={{ backgroundColor: "var(--landing-surface-alt)" }}
    >
      <div className="container mx-auto px-4 text-center">
        <h2
          className="text-3xl md:text-4xl font-bold mb-4 max-w-2xl mx-auto"
          style={{ color: "var(--landing-text)" }}
        >
          {t("cta.title")}
        </h2>
        <p
          className="text-lg mb-10 max-w-xl mx-auto leading-relaxed"
          style={{ color: "var(--landing-text-secondary)" }}
        >
          {t("cta.subtitle")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/register">
            <Button size="lg" className="landing-btn-primary text-base h-12 px-8 w-full sm:w-auto">
              {t("cta.register")}
              {isRTL ? (
                <ArrowLeft className="ml-2 h-5 w-5" />
              ) : (
                <ArrowRight className="mr-2 h-5 w-5" />
              )}
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outline"
              size="lg"
              className="landing-btn-outline text-base h-12 px-8 w-full sm:w-auto"
            >
              {t("cta.login")}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
